import type { ReactNode } from 'react';
import type { FeatureTypeEnum } from '@/api/hanly/hanlyAPI.schemas';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

interface ServerFeatureFlagProps {
  featureType: FeatureTypeEnum;
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * サーバーサイドの機能フラグに基づいて条件付きレンダリングを行うコンポーネント
 *
 * @example
 * ```tsx
 * <ServerFeatureFlag featureType="EDI">
 *   <Button>THIS IS NEW FEATURE</Button>
 * </ServerFeatureFlag>
 * ```
 */
export const ServerFeatureFlag = ({ featureType, children, fallback = null }: ServerFeatureFlagProps) => {
  const { isEnabled } = useFeatureFlag();

  return isEnabled(featureType) ? children : fallback;
};
